//
import HrContractPeriodModel from '@/models/HumanResource/HrContractPeriod'
import HrContractTypeModel from '@/models/HumanResource/HrContractType'

//
import { NoZeroRule, NoNegativeRule, RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default [
  {
    name: 'structure_name',
    type: 'text-field',
    props: {
      label: 'Nombre',
      rules: [RequiredRule],
    },
  },
  {
    name: 'hr_contract_type_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Tipo',
      model: HrContractTypeModel,
      noAsyncSearch: true,
      noObject: true,
      paramSearch: 'name',
      rules: [RequiredRule],
    },
  },
  {
    name: 'hr_contract_period_id',
    type: 'autocomplete-model',
    props: {
      itemText: 'name',
      itemValue: 'id',
      label: 'Periodo',
      model: HrContractPeriodModel,
      noAsyncSearch: true,
      noObject: true,
      paramSearch: 'name',
      rules: [RequiredRule],
    },
  },
  {
    name: 'weekly_hours',
    type: 'float-field',
    props: {
      label: 'Horas semanales',
      rules: [NoZeroRule, NoNegativeRule],
    },
  },
  {
    name: 'collation',
    type: 'currency-field',
    props: {
      label: 'Colación',
      rules: [NoNegativeRule],
    },
  },
  {
    name: 'mobilization',
    type: 'currency-field',
    props: {
      label: 'Movilización',
      rules: [NoNegativeRule],
    },
  },
  {
    name: 'base_salary',
    type: 'currency-field',
    props: {
      label: 'Salario base',
      rules: [NoZeroRule, NoNegativeRule],
    },
  },
]